import React from "react";
import { PlansB2BBlock } from "ComponentsUI/PlanB2B";
import { withRouter } from "react-router-dom";
import { PaddingBottom } from "ComponentsUI/Spacings";
import { Col } from "ComponentsUI/Styles/Grid";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";

var Routes = require("Configs/routes");
import { generateUrl } from "Services/withDefaultParams";

@withRouter
export default class PlansB2BLayout extends React.PureComponent {
	constructor(props) {
		super(props);
	}

	render() {
		const text = this.props.text;
		let classes = this.props.classes;
		let firstItems = [
			{
				speed: 50,
				limit: 0,
				type: 0,
				price: {
					price: 1400,
				},
				text: text.BUSINESS_TARIFF_CONNECTION_TIME,
			},
			{
				speed: 5,
				limit: 0,
				type: 0,
				price: {
					price: 900,
				},
				text: text.BUSINESS_TARIFF_CONNECTION_TIME,
			},
			{
				speed: 50,
				limit: 4,
				type: 0,
				price: {
					price: 500,
				},
				text: text.BUSINESS_TARIFF_CONNECTION_TIME,
			},
			{
				speed: 320,
				kbit: true,
				limit: 0,
				type: 0,
				price: {
					price: 300,
				},
				text: text.BUSINESS_TARIFF_CONNECTION_TIME,
			},
			{
				speed: 64,
				kbit: true,
				limit: 0,
				type: 0,
				price: {
					price: 0,
				},
				text: text.BUSINESS_TARIFF_CONNECTION_TIME,
			},
			{
				speed: 10,
				limit: 0,
				type: 1,
				price: {
					price: 750,
				},
				text: text.BUSINESS_TARIFF_CONNECTION_TIME,
			},
			{
				speed: 2,
				limit: 0,
				type: 2,
				price: {
					price: 2000,
				},
				text: text.BUSINESS_TARIFF_CONNECTION_TIME,
			},
			{
				speed: 5,
				limit: 0,
				type: 2,
				price: {
					old: 3000,
					price: 2800,
				},
				text: text.BUSINESS_TARIFF_CONNECTION_TIME,
			},
			{
				speed: 6,
				limit: 15,
				type: 2,
				price: {
					sale: 2000,
					price: 2450,
				},
				text: text.BUSINESS_TARIFF_CONNECTION_TIME,
			},
			{
				speed: 2,
				limit: 15,
				type: 3,
				price: {
					price: 1450,
				},
				text: text.BUSINESS_TARIFF_CONNECTION_TIME,
			},
		];
		let secondItems = [
			{
				speed: 10,
				limit: 0,
				type: 4,
				price: {
					price: 3800,
				},
				text: text.BUSINESS_TARIFF_CONNECTION_TIME,
			},
			{
				speed: 25,
				limit: 0,
				type: 4,
				price: {
					price: 6500,
				},
				text: text.BUSINESS_TARIFF_CONNECTION_TIME,
			},
			{
				speed: 10,
				limit: 0,
				type: 1,
				price: {
					price: 2700,
				},
				text: text.BUSINESS_TARIFF_CONNECTION_TIME,
			},
			{
				speed: 30,
				limit: 0,
				type: 1,
				price: {
					price: 5000,
				},
				text: text.BUSINESS_TARIFF_CONNECTION_TIME,
			},
			{
				speed: 10,
				limit: 0,
				type: 5,
				price: {
					price: "20 000",
				},
				text: text.BUSINESS_TARIFF_CONNECTION_TIME,
				withoutButton: true,
			},
			{
				speed: 30,
				limit: 0,
				type: 5,
				price: {
					price: "50 000",
				},
				text: text.BUSINESS_TARIFF_CONNECTION_TIME,
				withoutButton: true,
			},
		];

		let orderToOfficeUrl = generateUrl(Routes.Business.route, {
			regionUrl: this.props.match.params.regionUrl,
		});

		return (
			<PaddingBottom>
				<Container>
					<Row>
						<Col xs={12}>
							<PlansB2BBlock
								text={this.props.text}
								items={firstItems}
								header={text.TO_SMALL_BUSINESS}
								orderToOfficeUrl={orderToOfficeUrl}
							/>
							<PlansB2BBlock
								text={this.props.text}
								items={secondItems}
								header={text.TO_MEDIUM_BUSINESS}
								header2={text.TO_BIG_BUSINESS}
								orderToOfficeUrl={orderToOfficeUrl}
							/>
						</Col>
					</Row>
				</Container>
			</PaddingBottom>
		);
	}
}
